export default () => useNuxtApp().$auth
